var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CheckmarkRoundSmall = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("path", { d: 'M3.16663 8.00008C3.16663 5.33071 5.33058 3.16675 7.99996 3.16675C10.6693 3.16675 12.8333 5.33071 12.8333 8.00008C12.8333 10.6695 10.6693 12.8334 7.99996 12.8334C5.33058 12.8334 3.16663 10.6695 3.16663 8.00008Z', stroke: '#212A3D', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M6.5 8.5L6.78915 9.11625C7.01831 9.60464 7.70243 9.63278 7.97092 9.16486L9.5 6.5', stroke: '#212A3D', strokeLinecap: 'round', strokeLinejoin: 'round' })] })));
};
export { CheckmarkRoundSmall };
//# sourceMappingURL=CheckmarkRoundSmall.js.map